import { AlertFactory } from 'alerts/Alert'
import Member from 'iam/models/Member'
import { UserDataType } from 'iam/models/UserDataType'
import ProDetailsViewModel from 'iam/pro-details/ProDetailsViewModel'
import ProviderStore from 'iam/ProviderStore'
import UserDataStore from 'iam/UserDataStore'
import ModalViewModel from 'infra/ModalViewModel'
import { localStorage } from 'infra/storage'
import { action, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import { Observable } from 'rxjs'

const REVIEWED_KEY = 'software-stack-reviewed'

export default class ProSoftwareReviewModalViewModel extends ModalViewModel {
  @observable details: ProDetailsViewModel | null = null

  constructor(
    private newAlert: AlertFactory,
    private providerStore: ProviderStore,
    private userDataStore: UserDataStore,
    currentMember$: Observable<Member>,
  ) {
    super()
    makeObservable(this)

    // Offer the one-time software review when a pro lands after login.
    currentMember$.subscribe((member) => this.maybeShow(member))
  }

  @action
  async maybeShow(member: Member) {
    if (this.showing || localStorage.getItem(REVIEWED_KEY)) {
      return
    }

    const publicId = member.user.publicId
    await this.userDataStore.fetchByPublicId(publicId)
    const isPro =
      this.userDataStore.getByPublicId(publicId)?.userDataType ===
      UserDataType.Pro
    if (!isPro) {
      return
    }

    const details = new ProDetailsViewModel(
      this.newAlert,
      this.providerStore,
      publicId,
      true,
    )
    await details.load()
    this.details = details
    this.show()
  }

  confirm = task.resolved(async () => {
    if (!this.details) {
      return
    }

    const saved = await this.details.save()
    if (saved) {
      localStorage.setItem(REVIEWED_KEY, 'true')
      this.close()
    }
  })
}
